import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'
const helpers = createMultiStyleConfigHelpers([
    'details',
    'ingredientsMenu',
    'stepsMenu',
    'productSuggestion',
])
const RecipeDetails = helpers.defineMultiStyleConfig({
    baseStyle: {
        details: {
            detailsContainer: {w: '100%', flexDir: 'column', alignItems: 'center'},
            breadcrumbsContainer: {
                w: '100%',
                paddingX: {base: 'small.lg', lg: 'unset'},
                h: 'auto',
                paddingTop: {base: 'small.base', lg: 'small.lg'},
            },
            recipeInfoSudoContainer: {
                position: 'absolute',
                top: 0,
                left: 0,
                w: '100vw',
                h: '100%',
                zIndex: 0,
                borderTop: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            recipeInfoContainer: {
                flexDir: {base: 'column', lg: 'row'},
                w: '100%',
                alignItems: 'stretch',
            },
        },
        ingredientsMenu: {
            outerContainer: {
                bg: 'background.light-dark',
                width: '100%',
            },
            stickyContainer: {
                position: {base: 'relative', lg: 'sticky'},
                top: {base: '0', lg: 0},
                bg: 'background.light-dark',
                w: '100%',
                height: 'auto',
                paddingY: {base: 'small.base', lg: 'large.lg'},
                paddingRight: {
                    base: 'unset',
                    sm: 'unset',
                    md: 'unset',
                    lg: 'xlarge.base',
                },
            },
            ingredientsTitle: {
                paddingBottom: 'large.base',
                alignSelf: 'stretch',
                textStyle: 'head-medium',
                fontWeight: 'semibold',
            },
            servingsContainer: {w: '50%', paddingBottom: 'large.base', flexDir: 'column'},
            ingredientMenuTitle: {
                color: 'text.default',
                alignSelf: 'stretch',
                textStyle: 'head-xsmall',
                fontWeight: 'semibold',
                marginBottom: 'medium.base',
            },
            ingredientText: {alignSelf: 'stretch', textStyle: 'body-medium'},
            ingredientContainer: {w: '100%', paddingBottom: 'large.base', flexDir: 'column'},
            recipeUtensilsStyles: {
                container: {w: '100%'},
                flex: {
                    w: '100%',
                    flexDir: 'column',
                    alignItems: 'flex-start',
                    gap: remCalc(24),
                    paddingY: remCalc(24),
                },
                title: {textStyle: 'head-medium', fontWeight: 'semibold'},
                text: {textStyle: 'body-medium', fontWeight: 'normal'},
                divider: {w: '100%', borderBottom: '1px solid #D8D8D8', paddingY: '20px'},
                mobileText: {textStyle: 'body-large', fontWeight: 'normal'},
            },
        },
        stepsMenu: {
            stepsContainer: {
                width: '100%',
                bg: 'background.default',
            },
            innerContainer: {
                padding: {base: 'unset', lg: 'large.lg'},
                paddingRight: {base: 'unset', lg: 'unset'},
                paddingTop: {base: 'unset', lg: 'xlarge.base'},
            },
            stepsTitle: {
                textStyle: 'head-medium',
                fontWeight: 'semibold',
                paddingBottom: 'large.base',
            },
            stepContainer: {
                w: '100%',
                flexDir: 'column',
                gap: 'medium.base',
                paddingBottom: 'medium.lg',
            },
            stepImageContainer: {
                w: '100%',
                h: 'auto',
                alignSelf: 'center',
            },
            stepNumber: {textStyle: 'head-xmsall', fontWeight: 'medium'},
        },
        productSuggestion: {
            suggestionsContainer: {
                maxW: {base: remCalc(343), sm: remCalc(343), md: remCalc(343), large: 'unset'},
                gap: {base: 'medium.base', lg: '0'},
                flexDir: {base: 'column', lg: 'row'},
                width: '100%',
                alignItems: {base: 'center', lg: 'start'},
                paddingBottom: {base: 'xsmall.base', lg: 'large.lg'},
                paddingTop: {base: 'medium.base', lg: 'large.lg'},
            },
            maidWithContainer: {flexDir: 'column', h: 'auto', paddingX: 'small.lg'},
            textBoxTileContainer: {
                flexDir: 'column',
                h: '100%',
                minW: {base: 'unset', lg: 'xlarge.large'},
                padding: {base: 'medium.base', lg: 'large.lg'},
                paddingLeft: {base: 'medium.base', lg: 'unset'},
            },
            textBoxTitleText: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'semibold',
                marginBottom: 'medium.base',
                minW: {base: 'unset', lg: 'xlarge.large'},
                textAlign: {base: 'center', lg: 'unset'},
            },
            textBoxBodyText: {
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 'semibold',
                maxW: {base: 'unset', lg: remCalc(200)},
                minW: {base: 'unset', lg: 'xlarge.large'},
                textAlign: {base: 'center', lg: 'unset'},
            },
        },
    },
})

export default RecipeDetails
